import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Contact\CreateContactController::__invoke
* @see app/Http/Controllers/Contact/CreateContactController.php
* @route '/api/contact'
*/
const CreateContactController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateContactController.url(options),
    method: 'post',
})

CreateContactController.definition = {
    methods: ["post"],
    url: '/api/contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Contact\CreateContactController::__invoke
* @see app/Http/Controllers/Contact/CreateContactController.php
* @route '/api/contact'
*/
CreateContactController.url = (options?: RouteQueryOptions) => {
    return CreateContactController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Contact\CreateContactController::__invoke
* @see app/Http/Controllers/Contact/CreateContactController.php
* @route '/api/contact'
*/
CreateContactController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateContactController.url(options),
    method: 'post',
})

export default CreateContactController